import React, { useEffect, useState, useRef } from 'react';

import {
  Typography,
  Button,
  Descriptions,
  Collapse,
  Input,
  DatePicker,
  Select,
  Tooltip,
  Space,
  Tag,
  Dropdown,
  Menu,
} from 'antd';
import {
  CloseOutlined,
  SaveOutlined,
  PlusOutlined,
  UserOutlined,
  DownOutlined,
  LinkOutlined,
  SelectOutlined,
  LeftOutlined,
  RightOutlined,
  PartitionOutlined,
  GoldOutlined,
  CheckCircleOutlined,
  ExportOutlined,
  ThunderboltOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import dayjs from 'dayjs';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import UserAvatar from '../../../../components/userAvatar/index';
import {
  setsprintdata,
  setassigneelist,
  setbacklogdata,
  setEpiclist,
  setlabellist,
  setStoryPoints,
} from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import TaskSubtaskSection from './TaskSubtaskSection';
import TaskCommentSection from './TaskCommentSection';
import DetailsPage from './DetailsPage';
import { useSearchParams } from 'react-router-dom';
import SubtaskDetailModal from './SubtaskDetailModal';
import { SquareCheck } from 'lucide-react';
import {
  Box,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Popover,
  ModalFooter,
  HStack,
  Icon,
  IconButton,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from '@chakra-ui/react';
import Cookies from 'js-cookie';
import { FaEdit } from 'react-icons/fa';
import { useFetchBacklogData } from 'views/admin/taskManagement/BackLogPage/Alldata';
import TaskmodalActivity from '../Board/TaskmodalActivity';
import { FiExternalLink, FiX } from 'react-icons/fi';
import { FaLock, FaEye, FaShareAlt } from 'react-icons/fa';
import { AiOutlineThunderbolt } from 'react-icons/ai';
import { useContext } from 'react';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import TaskObject from '@atlaskit/object/task';
import LogWork from '../Board/LogWork';

import AttachmentList from '../Timeline/attachment/AttachmentList';

import ShareWorkItemModal from '../share/ShareWorkItemModal';
import LinkWorkItemInput from '../Board/LinkWorkItemInput';
import ListLinkedWorkItems from '../Board/ListLinkedWorkItems';
import WebLink from '../Board/WebLink';
import WebLinkList from '../Board/ListWebLinks';

import {
  useAttachmentContext,
  AttachmentProvider,
} from '../attachments/AttachmentProvider';

const { Title, Text } = Typography;
const { Panel } = Collapse;
const { Option } = Select;

const TaskDetailPanel = ({
  selectedTask,
  isPanelOpen,
  onClose,
  //fetchBacklogData,
  standalone = false,
  isSubtaskModalOpen,
  setIsSubtaskModalOpen,
  setSelectedSubtask,
  selectedSubtask,
  handleSubtaskClick,
  getSubTaskDetails,
  subtaskDetails,
  props,
}) => {
  const { id } = useParams();
  const projectId = Number(id);
  const { Panel } = Collapse;

  // Attachment context will be used inside AddMenu component which is inside the provider

  const roleId = Number(Cookies.get('task-role-id'));

  const [params] = useSearchParams();
  // const taskId = params.get("taskId");
  // console.log('taskId',taskId)

  // useEffect(() => {
  //   if (taskId) {
  //     fetchTaskById(taskId);
  //   }
  // }, [taskId]);

  const [taskdata, setTaskData] = useState({});
  const [loading, setLoading] = useState(false);

  const [attachments, setAttachments] = useState([]);

  const [isShareOpen, setIsShareOpen] = useState(false);

  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [editedTitle, setEditedTitle] = useState('');
  const [description, setDescription] = useState('');
  const [isEditingDesc, setIsEditingDesc] = useState(false);
  const [newstatus, setNewStatus] = useState('');
  //const [story_points, setStoryPoints] = useState('');
  const [startDate, setStartDate] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [assignee, setAssignee] = useState(
    subtaskDetails?.assignee_id || taskdata?.assignee_id || null,
  );
  const [epic, setEpic] = useState(
    taskdata?.epic_id || subtaskDetails?.epic_id || null,
  );
  const [labels, setLabels] = useState([]);
  const [sprint, setSprint] = useState(null);
  const [subtasks, setSubTasks] = useState([]);
  const [subtitledit, setSubTitleEdit] = useState('');
  const [selectedEpic, setSelectedEpic] = useState('');
  const [epicModalOpen, setEpicModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [openLinkWorkItem, setOpenLinkWorkItem] = useState(false);
  const [refreshLinkedItems, setRefreshLinkedItems] = useState(false);
  const [showWebLink, setShowWebLink] = useState(false);
  const [refreshLinks, setRefreshLinks] = useState(false);

  const [addingNew, setAddingNew] = useState(false);
  const [newSubtask, setNewSubtask] = useState({
    subtask_title: '',
    priority: 'Medium',
    assignee: '',
    status: 'To Do',
  });

  const [statusOptions, setStatusOptions] = useState([]);
  // const [assigneeOptions, setAssigneeOptions] = useState([]);
  // const [epicOptions, setEpicOptions] = useState([]);
  // const [labelOptions, setLabelOptions] = useState([]);
  const [sprintOptions, setSprintOptions] = useState([]);
  //const storyPoints = taskdata?.story_points || '';
  const story_points = useSelector(
    (state) => state.Authentication?.storyPoints,
  );

  const subtaskCount = taskdata?.subtask_status_count?.subtask_count;

  const dispatch = useDispatch();

  const [isExpanded, setIsExpanded] = useState(false);
  const [width, setWidth] = useState(600);
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [localIssueType, setLocalIssueType] = useState(
      taskdata?.issue_type_id
    );
  
    const [issuePopoverOpen, setIssuePopoverOpen] = useState(false);
  const isResizing = useRef(false);

  const startResize = () => (isResizing.current = true);

  const stopResize = () => (isResizing.current = false);

  const handleMouseMove = (e) => {
    if (!isResizing.current || !containerRef.current) return;
    const containerRight = containerRef.current.getBoundingClientRect().right;
    const newWidth = containerRight - e.clientX;
    if (newWidth > 400 && newWidth < 900) setWidth(newWidth);
  };

  const handleLogSaved = () => {
    setRefreshKey((prev) => prev + 1);
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', stopResize);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', stopResize);
    };
  }, []);

  const assigneeOptions = useSelector(
    (state) => state.Authentication?.assigneelist,
  );

  const epicOptions = useSelector((state) => state.Authentication?.Epiclist);

  const labelOptions = useSelector((state) => state.Authentication?.labellist);

  const { fetchBacklogData } = useFetchBacklogData(
    projectId,
    assigneeOptions,
    epicOptions,
    labelOptions,
  );

  // useEffect(() => {
  //   if (projectId && assigneeOptions) {
  //     fetchBacklogData(projectId);
  //   }
  // }, [projectId, assigneeOptions]);

  useEffect(() => {
    if (isPanelOpen && selectedTask) {
      fetchMetadata(projectId);
      getTaskData();
      fetchSubtaskData();
    }
  }, [isPanelOpen, selectedTask]);

  useEffect(() => {
    if (!containerRef.current) return;

    const computeExpanded = (width) => {
      setIsExpanded(width > 700);
    };

    computeExpanded(
      containerRef.current.offsetWidth || containerRef.current.clientWidth,
    );

    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = entry.contentRect?.width || entry.target.offsetWidth;
        computeExpanded(width);
      }
    });

    ro.observe(containerRef.current);

    return () => {
      ro.disconnect();
    };
  }, [containerRef]);

  useEffect(() => {
    if (containerRef.current) {
      const width =
        containerRef.current.offsetWidth || containerRef.current.clientWidth;
      setIsExpanded(width > 700);
    }
  }, [isPanelOpen]);

  const triggerRefresh = () => {
    setRefreshLinkedItems((prev) => !prev);
  };

  const handleSaveLink = (data) => {
   
    setRefreshLinks((prev) => !prev);
    // you can store it, send API, etc
    setShowWebLink(false);
  };

   const ISSUE_TYPES = [
      {
        id: 1,
        label: 'TASK',
        icon: <TaskObject size="small" />,
      },
      {
        id: 2,
        label: 'STORY',
        icon: <StoryObject size="small" />,
      },
      {
        id: 3,
        label: 'BUG',
        icon: <BugObject size="small" />,
      },
    ];

  const fetchMetadata = async (projectId) => {
    try {
      const [assigneeRes, epicRes, statusRes, labelRes] = await Promise.all([
        httpInjectorService.getProjectAssigneeList(projectId),
        httpInjectorService.getEpicList(projectId),
        httpInjectorService.ListBoardStatus(projectId),
        httpInjectorService.getLabelList(projectId),
      ]);

      if (assigneeRes?.status === 'success')
        // setAssigneeOptions(assigneeRes.data || []);
        dispatch(setassigneelist(assigneeRes.data));
      if (epicRes?.status === 'success')
        //  setEpicOptions(epicRes.data || []);
        dispatch(setEpiclist(epicRes.data));
      if (statusRes?.status === 'success')
        setStatusOptions(statusRes.data || []);
      if (labelRes?.status === 'success')
        // setLabelOptions(labelRes.data || []);
        dispatch(setlabellist(labelRes.data || []));
    } catch (error) {
      console.error('Error fetching metadata:', error);
    }
  };

  const getTaskData = async () => {
    const reqbody = {
      project_id: projectId,
      issue_id: selectedTask.id,
      issue_type_id: selectedTask.issue_type_id,
    };
    try {
      const response = await httpInjectorService.gettaskdata(reqbody);
      if (response.status === 'success') {
        const data = response.data;
        setTaskData(data);
        setEditedTitle(data.issue_title || '');
        setDescription(data.description || '');
        setNewStatus(data.issue_status || '');
        dispatch(setStoryPoints(data.story_points || ''));
        setStartDate(data.start_date || '');
        setDueDate(data.due_date || '');
        setAssignee(data.assignee_id || null);
        setEpic(data.epic_id || null);
        setLabels(data.labels || []);
        setSprint(data.sprint_id || null);
        fetchBacklogData();
      } else setTaskData({});
    } catch (err) {
      console.error(err);
    }
  };

  const counts = taskdata?.subtask_status_count || {};

  const autoSave = async (field, value) => {
    if (!taskdata?.issue_id) return;

    const payload = {
      issue_id: taskdata.issue_id,
      issue_type_id: taskdata.issue_type_id,
      project_id: taskdata.project_id,
      epic_id: taskdata.epic_id || null,
      sprint_id: taskdata.sprint_id || null,
      story_points: taskdata.story_points || null,
      assignee_id: taskdata.assignee_id || null,
      issue_priority: taskdata.issue_priority || null,
      issue_status: taskdata.issue_status || null,
      issue_title: taskdata.issue_title || '',
      description: taskdata.description || '',
      start_date: taskdata.start_date
        ? dayjs(taskdata.start_date).format('YYYY-MM-DD')
        : null,
      due_date: taskdata.due_date
        ? dayjs(taskdata.due_date).format('YYYY-MM-DD')
        : null,
      work_item_url: `${window.location.origin}/admin/taskBoard/${taskdata.project_id}/taskDetails/${taskdata.issue_id}`,
    };

    payload[field] = value;

    try {
      setLoading(true);
      const res = await httpInjectorService.Taskedit(payload);

      if (res?.status === 'success') {
        setTaskData((prev) => ({ ...prev, [field]: value }));

        await fetchBacklogData();
      }
    } catch (error) {
      console.error('AutoSave failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubtaskData = async () => {
    let reqbody = {
      project_id: projectId,
      issue_id: selectedTask.id,
    };
    try {
      const response = await httpInjectorService.getsubtaskList(reqbody);

      setSubTasks(response.data);
    } catch (error) {
      console.error('Error fetching subtasks:', error);
    }
  };

  const handleAddLabel = async (updatedLabels) => {
    try {
      if (!updatedLabels || updatedLabels.length === 0) return;

      const newLabels = updatedLabels.filter((label) => label.__isNew__);
      const existingLabels = updatedLabels.filter((label) => !label.__isNew__);

      const newLabelNames = newLabels.map((label) => label.label);

      const existingLabelIds = existingLabels.map(
        (label) => label.label_id || label.value,
      );

      const requestBody = {
        issue_id: taskdata.issue_id,
        issue_type_id: taskdata.issue_type_id,
        project_id: taskdata.project_id,
        sprint_id: taskdata.sprint_id || null,
        label_ids: updatedLabels.map((l) => l.label_id || l.value),
      };

      if (newLabelNames.length > 0) {
        requestBody.new_label_name = newLabelNames;
      }

      if (existingLabelIds.length > 0) {
        requestBody.labels_id = existingLabelIds;
      }

      const response = await httpInjectorService.createLabel(requestBody);

      if (response.status === 'success') {
        fetchBacklogData?.();
        if (response.data?.updatedLabels) {
          setLabels(response.data.updatedLabels);
        }
      } else {
        console.warn('Failed to add labels:', response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong while adding labels', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const handleMenuClick = (e) => {
    const selected = e.key;
    setNewStatus(selected);
    autoSave('issue_status', selected);
  };

  const handleAddNew = () => {
    if (!newSubtask.subtask_title.trim()) return;
    const newEntry = { subtask_key: Date.now(), ...newSubtask };
    setSubTasks((prev) => [...prev, newEntry]);
    handleAddSubtask();

    setAddingNew(false);
    setNewSubtask({
      subtask_title: '',
      priority: 'Medium',
      assignee: '',
      status: 'To Do',
    });
  };

  const handleAddSubtask = async () => {
    const reqbody = {
      project_id: projectId,
      issue_id: selectedTask.id,
      issue_type_id: selectedTask.issue_type_id,
      issue_type: selectedTask.issue_type,
      sprint_id: sprint,
      title: newSubtask.subtask_title || subtitledit || '',
      description: null,
      subtask_status: 'TO DO',
      subtask_priority: 'Medium',
      start_date: null,
      due_date: null,
      labels_id: null,
      subtask_assignee_id: null,
    };

    try {
      const response = await httpInjectorService.addSubtask(reqbody);
      if (response.status === 'success') {
        setSubTitleEdit('');
        setAddingNew(false);
        fetchSubtaskData();
        setNewSubtask('');
      } else {
        console.error('Failed to add subtask');
      }
    } catch (error) {
      console.error('Error adding subtask:', error);
    }
  };

  const getStatusColors = (status = '') => {
    const s = String(status || '')
      .toUpperCase()
      .trim();

    switch (s) {
      case 'DONE':
        return { bg: '#45d44fff', color: 'black' };
      case 'TO DO':
      case 'TODO':
        return { bg: '#E6E6E6', color: 'black' };
      default:
        return { bg: '#55b0e8ff', color: 'black' };
    }
  };

  const fetchAttachments = async () => {
    try {
      if (!taskdata?.project_id || !taskdata?.issue_id) return;

      const payload = {
        project_id: taskdata.project_id,
        epic_id: taskdata?.epic_id || null,
        epic_key: taskdata?.epic_key || null,
        issue_id: taskdata?.issue_id || null,
        issue_key: taskdata?.issue_key || null,
      };

      const res = await httpInjectorService.getAttachment(payload);

      if (res?.status === 'success') {
        setAttachments(res.data || []);
      } else {
        setAttachments([]);
      }
    } catch (err) {
      console.error('Error fetching attachments:', err);
      setAttachments([]);
    }
  };

  const handleOpenLinkWorkItem = () => {
    setOpenLinkWorkItem(true);
  };

  const handleopenweblink = () => {
    setShowWebLink(true);
  };
  // delete attachment
  const handleDeleteAttachment = async (id) => {
    setAttachments((prev) => prev.filter((att) => att.attachment_id !== id));

    // Optional backend api call
    await httpInjectorService.deleteAttachment({
      attachment_id: id,
      project_id: taskdata.project_id,
    });

    toast.success('Attachment removed', {
      position: 'top-right',
      autoClose: 3000,
    });
  };

 
  const ISSUE_TYPE_ICON_MAP = {
    1: TaskObject, // TASK
    2: StoryObject, // STORY
    3: BugObject, // BUG
  };

  const IssueIcon =
    ISSUE_TYPE_ICON_MAP[
      selectedTask.issue_type_id || selectedTask.task.issue_type_id
    ];

    const selectedIssue =
    ISSUE_TYPES.find((i) => i.id === localIssueType) ||
    ISSUE_TYPES[0];

  // File upload is now handled by AttachmentProvider

  // Sync taskDetails → taskdata
  useEffect(() => {
    if (taskdata) {
      setTaskData(taskdata.task || taskdata);
    }
  }, [taskdata]);

  useEffect(() => {
    if (isPanelOpen && taskdata?.project_id && taskdata?.issue_id) {
      fetchAttachments();
    }
  }, [isPanelOpen, taskdata?.project_id, taskdata?.issue_id]);

  const menu = (
    <Menu onClick={handleMenuClick}>
      {statusOptions.map((s) => {
        const colors = getStatusColors(s.status_name);

        return (
          <Menu.Item key={s.status_name}>
            <span
              style={{
                backgroundColor: colors.bg,
                color: colors.color,
                fontWeight: 600,
                borderRadius: 30,
                padding: '3px 10px',
                fontSize: 12,
                display: 'inline-block',
                textTransform: 'uppercase',
              }}
            >
              {s.status_name}
            </span>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  const currentStatus = newstatus || taskdata.issue_status;
  const colors = getStatusColors(currentStatus);

  // Component that uses attachment context - must be inside AttachmentProvider
  const AddMenuDropdown = ({ setAddingNew }) => {
    const { openFilePicker } = useAttachmentContext() || {};

    const addMenu = (
      <Menu
        onClick={({ key }) => {
          switch (key) {
            case 'subtask':
              setAddingNew((prev) => !prev);
              break;

            case 'linkWork':
              handleOpenLinkWorkItem();
           
              break;

            case 'addattachment':
              if (openFilePicker) {
                openFilePicker();
              }
              break;

            case 'addweblink':
              handleopenweblink();
            
              break;

            case 'page':
            
              break;

            case 'whiteboard':
             
              break;

            default:
              break;
          }
        }}
        items={[
          {
            key: 'subtask',
            label: 'Create child work item',
          },
          {
            key: 'linkWork',
            label: 'Link work Items',
          },
          {
            key: 'addattachment',
            label: 'Add Attachment',
          },
          {
            key: 'addweblink',
            label: 'Add web link',
          },
          {
            key: 'page',
            label: 'Page',
          },
          {
            key: 'whiteboard',
            label: 'Whiteboard',
          },
        ]}
      />
    );

    return (
      <Dropdown overlay={addMenu} trigger={['click']}>
        <Button
          icon={<PlusOutlined />}
          type="default"
          style={{
            borderRadius: 20,
            fontWeight: 600,
            border: '1px solid #d9d9d9',
            background: '#fff',
          }}
        />
      </Dropdown>
    );
  };

  return (
    <AttachmentProvider
      context={{
        project_id: taskdata?.project_id || projectId,
        epic_id: taskdata?.epic_id || selectedTask?.epic_id || null,
        epic_key: taskdata?.epic_key || selectedTask?.epic_key || null,
        issue_id:
          taskdata?.issue_id ||
          selectedTask?.id ||
          selectedTask?.issue_id ||
          null,
        issue_key:
          taskdata?.issue_key ||
          selectedTask?.key ||
          selectedTask?.issue_key ||
          null,
      }}
      onUploaded={fetchAttachments}
    >
      {/* <div
        ref={containerRef}
        style={{
          display: 'flex',
          flexDirection: isExpanded ? 'row' : 'column',
          height: '100%',
          background: '#fff',
          transition: 'all 0.3s ease',
          borderLeft: standalone ? 'none' : '1px solid #ddd',
        }}
      > */}
      {/* LEFT MAIN CONTENT */}
      <div
        style={{
          flex: isExpanded ? 2 : 1,
          overflowY: 'auto',
          paddingRight: 12,
        }}
      >
        {/* Header */}
        {/* <div
            style={{
              padding: '16px 20px',
              borderBottom: '1px solid #eaeaea',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              background: '#f7f8fa',
            }}
          > */}
        {/* <div> */}
        <Flex
          align="center"
          justify="space-between"
          px={4}
          py={2}
          borderBottom="1px solid #e2e8f0"
          bg="white"
          //flex="0 0 50px"

          height="48px"
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 100,
          }}
        >
          {/* Left: NubaxPulse WorkItem */}
          <Text fontWeight="600" color="black" fontSize="15px">
            NubaxPulse WorkItem
          </Text>

          {/* Right: Open in new tab + close */}
          <Flex align="center" gap={4}>
            <Tooltip title="Open in new tab">
              <a
                href={`/admin/taskBoard/${projectId}/taskDetails/${selectedTask?.id}`}
                rel="noopener noreferrer"
                target="_blank"
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                }}
              >
                <Icon as={FiExternalLink} boxSize={5} color="gray.700" />
              </a>
            </Tooltip>

            <Icon
              as={FiX}
              boxSize={5}
              color="gray.700"
              cursor="pointer"
              _hover={{ color: 'red.500' }}
              onClick={onClose}
            />
          </Flex>
        </Flex>

        <Flex
          justify="space-between"
          align="center"
          px={6}
          py={2}
          flex="0 0 50px"
          borderBottom="1px solid #e2e8f0"
          bg="white"
        >

          <HStack spacing={1} align="center">
            {/* Epic */}
            <HStack spacing={1} align="center">
              <ThunderboltOutlined
                style={{
                  color: '#884B9E',
                  fontSize: '18px',
                }}
              />
          
              <Text fontSize="md" color="gray.600" mt="12px">
              {selectedEpic || taskdata?.epic_key}
              </Text>
          
              <Text fontSize="md" color="gray.600" mt="12px">
                /
              </Text>
            </HStack>
          
            {/* Issue Type */}
            <Popover
              isOpen={issuePopoverOpen}
              onClose={() => setIssuePopoverOpen(false)}
              placement="bottom-start"
            >
              <PopoverTrigger>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setIssuePopoverOpen(!issuePopoverOpen);
                  }}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                  }}
                >
                  {selectedIssue.icon}
          
                  <Text fontSize="md" color="gray.600" m={0}>
                    {selectedTask?.task?.key || selectedTask?.key}
                  </Text>
                </div>
              </PopoverTrigger>
          
              <PopoverContent width="140px">
                <PopoverBody p={1}>
                  {ISSUE_TYPES.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => {
                        setLocalIssueType(item.id);
                        autoSave('issue_type_id', item.id);
                        setIssuePopoverOpen(false);
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        padding: '6px 8px',
                        borderRadius: 6,
                        cursor: 'pointer',
                      }}
                    >
                      {item.icon}
                      <span>{item.label}</span>
                    </div>
                  ))}
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </HStack>
          {/* Left: Epic Key + Task Key */}
        

          {/* Right: Lock, Eye, Share, Flash */}
          <HStack spacing={2}>
            <IconButton icon={<FaLock />} size="sm" variant="ghost" />
            <LogWork
              work_Id={taskdata?.issue_id}
              work_Type="ISSUE"
              taskDetails={taskdata}
              onSaved={handleLogSaved}
            />
            <IconButton icon={<FaEye />} size="sm" variant="ghost" />
            <IconButton
              icon={<FaShareAlt />}
              size="sm"
              variant="ghost"
              onClick={() => setIsShareOpen(true)}
            />
            <IconButton
              icon={<AiOutlineThunderbolt />}
              size="sm"
              variant="ghost"
            />
          </HStack>
        </Flex>

        <div style={{ padding: '12px 16px' }}>
          {isEditingTitle ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                marginTop: 4,
              }}
            >
              <Input
                value={editedTitle}
                onChange={(e) => setEditedTitle(e.target.value)}
                autoFocus
                style={{ fontSize: 20, fontWeight: 700 }}
                onPressEnter={() => {
                  autoSave('issue_title', editedTitle);
                  setIsEditingTitle(false);
                }}
              />

              <Space>
                <CheckOutlined
                  style={{ fontSize: 20, color: 'green', cursor: 'pointer' }}
                  onClick={() => {
                    autoSave('issue_title', editedTitle);
                    setIsEditingTitle(false);
                  }}
                />

                <CloseOutlined
                  style={{ fontSize: 20, color: 'red', cursor: 'pointer' }}
                  onClick={() => {
                    setEditedTitle(taskdata?.issue_title || '');
                    setIsEditingTitle(false);
                  }}
                />
              </Space>
            </div>
          ) : (
            <Title
              level={4}
              style={{ margin: 0, cursor: 'pointer' }}
              onClick={() => setIsEditingTitle(true)}
            >
              {taskdata?.issue_title || 'Untitled Task'}
            </Title>
          )}

          {/* Status & Add dropdown */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginTop: 8,
            }}
          >
            <Dropdown overlay={menu} trigger={['click']}>
              <Button
                type="default"
                style={{
                  borderRadius: 20,
                  backgroundColor: colors.bg,
                  color: colors.color,
                  fontWeight: 600,
                  border: '1px solid rgba(56, 112, 190, 1)',
                  textTransform: 'uppercase',
                  fontSize: 12,
                  padding: '2px 14px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => autoSave('issue_status', taskdata.issue_status)}
              >
                {currentStatus}
                <DownOutlined style={{ fontSize: 10, marginLeft: 6 }} />
              </Button>
            </Dropdown>

            <AddMenuDropdown setAddingNew={setAddingNew} />
          </div>
        </div>
        {/* </div> */}
        {/* </div> */}

        {/* Content */}
        <div style={{ padding: '20px', overflowY: 'auto', flex: 1 }}>
          <Collapse
            accordion={false}
            bordered={false}
            defaultActiveKey={['desc', 'subtask', 'details', 'activity']}
            expandIconPosition="end"
            style={{ background: 'transparent' }}
          >
            {/* Description */}
            <Panel
              header={
                <span style={{ fontSize: 18, fontWeight: 600 }}>
                  Description
                </span>
              }
              key="desc"
              style={{ background: 'transparent' }}
            >
              {isEditingDesc ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12,
                    paddingBottom: 16,
                  }}
                >
                  <div
                    style={{
                      border: '1px solid #d9d9d9',
                      borderRadius: 6,
                      overflow: 'hidden',
                    }}
                  >
                    <ReactQuill
                      value={description}
                      onChange={setDescription}
                      theme="snow"
                      style={{
                        height: 180,
                        marginBottom: 0,
                      }}
                    />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      type="primary"
                      size="small"
                      loading={loading}
                      onClick={async () => {
                        await autoSave('description', description);
                        setIsEditingDesc(false);
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      size="small"
                      type="text"
                      onClick={() => setIsEditingDesc(false)}
                    >
                      cancel
                    </Button>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    padding: '12px',
                    borderRadius: 6,
                    minHeight: 80,
                    cursor: 'pointer',
                  }}
                  onClick={() => setIsEditingDesc(true)}
                  dangerouslySetInnerHTML={{
                    __html:
                      taskdata?.description ||
                      '<p style="color:gray;">Add a description...</p>',
                  }}
                />
              )}

              {/* Attachment upload UI */}
              <Box mb={6}>
                {attachments?.length > 0 && (
                  <AttachmentList
                    onDelete={handleDeleteAttachment}
                    attachments={attachments}
                  />
                )}
              </Box>
            </Panel>

             {openLinkWorkItem && (
              <div style={{ marginTop: '16px' }}>
                <LinkWorkItemInput
                  onCancel={() => setOpenLinkWorkItem(false)}
                  current_item_type={'issue'}
                  current_item_id={taskdata.issue_id}
                  onSuccess={triggerRefresh}
                />
              </div>
            )}
            {showWebLink && (
              <WebLink
                onClose={() => setShowWebLink(false)}
                onSave={handleSaveLink}
                work_id={taskdata.issue_id}
                work_type={'issue'}
              />
            )}

          


            <Tabs variant="unstyled" mt="12px">
              {/* Tabs */}
              <TabList gap={2}>
                <Tab
                  fontSize="12px"
                  px="8px"
                  py="3px"
                  _selected={{
                    border: '1px solid #3182CE',
                    color: '#3182CE',
                    bg: 'white',
                    borderRadius: '4px',
                  }}
                >
                  Subtasks
                </Tab>

                <Tab
                  fontSize="12px"
                  px="8px"
                  py="3px"
                  _selected={{
                    border: '1px solid #3182CE',
                    color: '#3182CE',
                    bg: 'white',
                    borderRadius: '4px',
                  }}
                >
                  Linked Items
                </Tab>
              </TabList>

              {/* Tab Content */}
              <TabPanels mt={4}>
                {/* Subtasks */}
                <TabPanel p={0}>
                  <Collapse defaultActiveKey={['subtask']} ghost>
                    <Panel
                      header={
                        <span style={{ fontSize: 18, fontWeight: 600 }}>
                          Subtask{' '}
                          <span
                            style={{
                              fontSize: 14,
                              fontWeight: 400,
                              color: '#6b7280',
                            }}
                          >
                            ({subtaskCount} work items)
                          </span>
                        </span>
                      }
                      key="subtask"
                      style={{ background: 'transparent' }}
                    >
                      <div style={{ marginBottom: 24 }}>
                        <TaskSubtaskSection
                          taskId={taskdata?.id}
                          assignee={assignee}
                          setAssignee={setAssignee}
                          assigneeOptions={assigneeOptions || []}
                          statusOptions={statusOptions || []}
                          setStatusOptions={setStatusOptions}
                          autoSave={autoSave}
                          fetchSubtaskData={fetchSubtaskData}
                          subtasks={subtasks}
                          setSubTasks={setSubTasks}
                          projectId={projectId}
                          handleAddNew={handleAddNew}
                          addingNew={addingNew}
                          setAddingNew={setAddingNew}
                          newSubtask={newSubtask}
                          setNewSubtask={setNewSubtask}
                          handleAddSubtask={handleAddSubtask}
                          onClose={onClose}
                          setSelectedSubtask={setSelectedSubtask}
                          setIsSubtaskModalOpen={setIsSubtaskModalOpen}
                          isSubtaskModalOpen={isSubtaskModalOpen}
                          handleSubtaskClick={handleSubtaskClick}
                          selectedSubtask={selectedSubtask}
                          getStatusColors={getStatusColors}
                          taskdata={taskdata}
                          selectedTask={selectedTask}
                        />
                      </div>
                    </Panel>
                  </Collapse>
                </TabPanel>

                {/* Linked Items */}
                <TabPanel p={0}>
                  <ListLinkedWorkItems
                    item_id={taskdata.issue_id}
                    item_type={'issue'}
                    refreshFlag={refreshLinkedItems}
                  />
                </TabPanel>
              </TabPanels>
            </Tabs>

              <WebLinkList
              work_id={taskdata.issue_id}
              work_type={'issue'}
              refreshFlag={refreshLinks}
            />

            {/* Subtask */}

           
            {/* Detail */}

            {/* {!isExpanded && ( */}
            <Panel
              header={
                <span style={{ fontSize: 18, fontWeight: 600 }}>Details</span>
              }
              key="details"
              style={{ background: 'transparent' }}
            >
              <DetailsPage
                taskdata={taskdata}
                assignee={assignee}
                setAssignee={setAssignee}
                assigneeOptions={assigneeOptions || []}
                labelOptions={labelOptions || []}
                labels={labels}
                setLabels={setLabels}
                epicOptions={epicOptions || []}
                epic={epic}
                setEpic={setEpic}
                dueDate={dueDate}
                setDueDate={setDueDate}
                startDate={startDate}
                setStartDate={setStartDate}
                story_points={story_points}
                setStoryPoints={setStoryPoints}
                autoSave={autoSave}
                handleAddLabel={handleAddLabel}
                projectId={projectId}
              />
            </Panel>
            {/* )} */}

            {/* Activity */}
            <Panel
              header={
                <span style={{ fontSize: 18, fontWeight: 600 }}>Activity</span>
              }
              key="activity"
              style={{ background: 'transparent' }}
            >
              <div style={{ marginBottom: 24 }}>
                <TaskCommentSection
                  taskId={selectedTask?.id}
                  issueTypeId={selectedTask?.issue_type_id}
                  projectId={projectId}
                  assigneeOptions={assigneeOptions || []}
                  taskdata={taskdata}
                  refreshKey={refreshKey}
                />
              </div>
            </Panel>
          </Collapse>
        </div>
      </div>

      {/* RIGHT DETAILS PANEL */}
      {/* Details */}
      {/* {isExpanded && (
        <>
      
          <div
            onMouseDown={startResize}
            style={{
              width: 6,
              cursor: 'col-resize',
              background: '#f0f0f0',
              borderLeft: '1px solid #d9d9d9',
              borderRight: '1px solid #d9d9d9',
              transition: 'background 0.2s',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = '#e0e0e0')}
            onMouseLeave={(e) => (e.currentTarget.style.background = '#f0f0f0')}
          />


          <div
            style={{
              width,
              background: '#fafafa',
              borderLeft: '1px solid #e8e8e8',
              overflowY: 'auto',
              transition: 'width 0.1s ease-out',
            }}
          >
       
            <div
              style={{
                padding: '14px 20px',
                borderBottom: '1px solid #eaeaea',
                background: '#f7f8fa',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span style={{ fontSize: 18, fontWeight: 600 }}>Details</span>

              <Button
                type="text"
                size="small"
                onClick={() => setIsExpanded(false)}
                icon={<CloseOutlined />}
              />
            </div>

         
            <div style={{ padding: '20px' }}>
              <DetailsPage
                taskdata={taskdata}
                assignee={assignee}
                setAssignee={setAssignee}
                assigneeOptions={assigneeOptions || []}
                labelOptions={labelOptions || []}
                labels={labels}
                setLabels={setLabels}
                epicOptions={epicOptions || []}
                epic={epic}
                setEpic={setEpic}
                dueDate={dueDate}
                setDueDate={setDueDate}
                startDate={startDate}
                setStartDate={setStartDate}
                storyPoints={storyPoints}
                setStoryPoints={setStoryPoints}
                autoSave={autoSave}
                handleAddLabel={handleAddLabel}
              />
            </div>
          </div>
        </>
      // )} */}

      <ShareWorkItemModal
        isOpen={isShareOpen}
        onClose={() => setIsShareOpen(false)}
        issue_id={
          taskdata?.issue_id ||
          selectedTask?.id ||
          selectedTask?.issue_id ||
          null
        }
        issue_type_id={
          taskdata?.issue_type_id || selectedTask?.issue_type_id || null
        }
        epic_id={taskdata?.epic_id}
        project_id={taskdata.project_id || projectId}
        // taskKey={taskDetails?.task_key || taskDetails?.task?.task_key}
      />

      <Modal
        isOpen={epicModalOpen}
        onClose={() => {
          setEpicModalOpen(false);
          fetchBacklogData();
        }}
        isCentered
      >
        <ModalOverlay />
        <ModalContent maxW="700px" minH="300px">
          {' '}
          {/* Increase width here */}
          <ModalHeader>Add Epic</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text mb={3}>
              Select a parent work item. Work items can only belong to one
              parent at a time.
            </Text>
            <Select
              placeholder="Select Parent"
              value={selectedEpic}
              onChange={(e) => setSelectedEpic(Number(e.target.value))}
              mt={3}
            >
              {epicOptions.map((epic) => (
                <option key={epic.epic_id} value={epic.epic_id}>
                  {epic.epic_name}
                </option>
              ))}
            </Select>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                // Replace with API call
                setEpicModalOpen(false);
              }}
            >
              Add
            </Button>
            <Button variant="ghost" onClick={() => setEpicModalOpen(false)}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* </div> */}
    </AttachmentProvider>
  );
};

export default TaskDetailPanel;
